import { render, staticRenderFns } from "./partnerInvoicesPanel.vue?vue&type=template&id=427d4103&"
import script from "./partnerInvoicesPanel.vue?vue&type=script&lang=ts&"
export * from "./partnerInvoicesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports